module.exports = __webpack_public_path__ + "img/icon-game-10826.db2a33b2.png";